import { render, staticRenderFns } from "./TablePeopleAnalysisList.vue?vue&type=template&id=6b0ffe92&"
import script from "./TablePeopleAnalysisList.vue?vue&type=script&lang=js&"
export * from "./TablePeopleAnalysisList.vue?vue&type=script&lang=js&"
import style0 from "./TablePeopleAnalysisList.vue?vue&type=style&index=0&id=6b0ffe92&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0ffe92')) {
      api.createRecord('6b0ffe92', component.options)
    } else {
      api.reload('6b0ffe92', component.options)
    }
    module.hot.accept("./TablePeopleAnalysisList.vue?vue&type=template&id=6b0ffe92&", function () {
      api.rerender('6b0ffe92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TablePeopleAnalysisList.vue"
export default component.exports